import Details from "../../EventDetailsPage"
import Competitions from "./Competitions"
import Announcements from "./Annoncements/index"
import Sponsors from "./Sponsors"
import Reviews from './Reviews'

import Logistics from "./Logistics"

// The first tab is the fallback for a tab the current role cannot open.
const EventTabs = [
  { url: "details", label: "Event details", Component: Details },
  { url: "competitions", label: "Competitions", Component: Competitions },
  { url: "announcements", label: "Announcements", Component: Announcements },
  { url: "sponsors", label: "Sponsors", Component: Sponsors },
  { url: 'reviews', label: 'Match reviews', Component: Reviews, superAdminOnly: true },

  { url: "logistics", label: "Logistics", Component: Logistics, superAdminOnly: true },
]

export default EventTabs
